import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import Fade from '../fade/Fade';
const BaseSpinner = (props) => {
    const { isInverse, isDoubleSized, ...remainingProps } = props;
    const className = classNames('spinner', { inverse: isInverse, double: isDoubleSized });
    return (_jsxs("div", { ...remainingProps, className: className, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }));
};
const Spinner = (props) => {
    const { isInverse = false, isFullSized = false, isFullScreen = false, isDoubleSized = false, isInline = false, show = false, text, ...remainingProps } = props;
    const baseSpinner = _jsx(BaseSpinner, { isDoubleSized: isDoubleSized, isInverse: isInverse, ...remainingProps });
    if (isInline) {
        return baseSpinner;
    }
    const classes = classNames(['spinnerInfoBox', 'display-flex', 'justify-content-center', 'align-items-center', 'height-100pct'], { fullsized: isFullSized, fullscreen: isFullScreen });
    const wrappedSpinner = (_jsxs("div", { className: classes, children: [baseSpinner, text && _jsx("div", { className: 'spinnerText', children: text })] }));
    if (isFullScreen || isFullSized) {
        return (_jsx(Fade, { show: show, duration: 0.1, children: wrappedSpinner }));
    }
    return wrappedSpinner;
};
export default Spinner;
